import Any from "./Any"

export default class Number extends Any {
  constructor() {
    super()

    this.type = `number`
  }
}
